import { render, staticRenderFns } from "./InviteForm.vue?vue&type=template&id=ee3c3622"
import script from "./InviteForm.vue?vue&type=script&lang=js"
export * from "./InviteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports